import React from 'react';
import cn from 'classnames';
import {ComponentSize, StandardProps} from '..';
import FormControlContext from '../FormControl/FormControlContext';
import useFormControl from '../FormControl/useFormControl';

type InputAdornmentPosition = 'start' | 'end';

function getAdornmentClassName(position?: InputAdornmentPosition) {
  switch (position) {
    case 'start':
      return 'input-inline-adornment__root--start';
    case 'end':
      return 'input-inline-adornment__root--end';
    default:
      return '';
  }
}

function getFormControlSizeClassName(size?: ComponentSize) {
  switch (size) {
    case 'extra-small':
      return 'input-inline-adornment__root--extra-small';
    case 'small':
      return 'input-inline-adornment__root--small';
    case 'medium':
      return 'input-inline-adornment__root--medium';
    case 'large':
      return 'input-inline-adornment__root--large';
    default:
      return '';
  }
}

export interface InputAdornmentProps extends StandardProps<React.HTMLAttributes<HTMLDivElement>> {
  position?: InputAdornmentPosition;
}

export const InputAdornment = React.forwardRef<HTMLDivElement, InputAdornmentProps>((props, ref) => {
  const {
    children,
    className,
    position,
    ...other
  } = props;

  const formControl = useFormControl() || {};

  return (
    <FormControlContext.Provider value={null}>
      <div
        className={cn(
          'input-inline-adornment input-inline-adornment__root',
          className,
          getAdornmentClassName(position),
          getFormControlSizeClassName(formControl.size),
        )}
        ref={ref}
        {...other}
      >
        {children}
      </div>
    </FormControlContext.Provider>
  );
});

export default InputAdornment;
